// extracted by mini-css-extract-plugin
export default {"GateBody":"expressionEval_GateBody__B5P2J","SettingsContainer":"expressionEval_SettingsContainer__Gu7rt","SwitchContainer":"expressionEval_SwitchContainer__fK+rQ"};